import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  IViewTransaction,
  IViewVirtualAccountTransferRefund,
} from "../../../interfaces-and-types";
import {
  useMerchantApiQueryWithParams,
  useReactRouterLink,
} from "../../../hooks";
import { View } from "./View";

export interface IVirtualAccountTransferRefundDetailsModalViewProps {
  isLoading: boolean;
  isError: boolean;
  isModalOpen: boolean;
  closeModal: () => void;
  modalData: IViewVirtualAccountTransferRefund | null;
  // source tx
  isLoadingSourceTxDetails: boolean;
  isErrorSourceTxDetails: boolean;
  sourceTxDetails: IViewTransaction | null;
  // parent tx
  isLoadingParentTxDetails: boolean;
  isErrorParentTxDetails: boolean;
  parentTxDetails: IViewTransaction | null;
}

export const VirtualAccountTransferRefundDetailsModal = () => {
  const { location, navigateToRoutePreserveParams } = useReactRouterLink();

  const [isFirstNavToDetails, setFirstNavToDetails] = useState(true);

  const closeModal = () => {
    navigateToRoutePreserveParams(
      location.pathname.replace(`${id}/details`, "")
    );
  };

  const { id } = useParams();

  useEffect(() => {
    setFirstNavToDetails(false);
  }, [id]);

  const {
    isLoading: isLoadingRefundDetails,
    isSuccess: isSuccessRefundDetails,
    isError: isErrorRefundDetails,
    data: refund,
  } = useMerchantApiQueryWithParams<
    { id: string },
    IViewVirtualAccountTransferRefund
  >(
    [
      "getVirtualAccountTransferRefundById", // virtual-account-transfer-refunds
      {
        id: id!, // NOTE: use this to ensure that react query caches with the correct queryKey
      },
    ],
    {
      enabled: !!id,
    },
    (urlTemplate) => urlTemplate.replace("id", id!)
  );

  const {
    isLoading: isLoadingSourceTxDetails,
    isSuccess: isSuccessSourceTxDetails,
    isError: isErrorSourceTxDetails,
    data: sourceTxDetails,
  } = useMerchantApiQueryWithParams<{ id: string }, IViewTransaction>(
    [
      "getTransactionById",
      {
        id: refund?.transaction_id!,
      },
    ],
    {
      enabled: isSuccessRefundDetails && !!refund,
    },
    (urlTemplate) => urlTemplate.replace("id", refund?.transaction_id!)
  );

  const {
    isLoading: isLoadingParentTxDetails,
    isSuccess: isSuccessParentTxDetails,
    isError: isErrorParentTxDetails,
    data: parentTxDetails,
  } = useMerchantApiQueryWithParams<{ id: string }, IViewTransaction>(
    [
      "getTransactionById",
      {
        id: sourceTxDetails?.partial_payment_parent_id!,
      },
    ],
    {
      enabled:
        isSuccessSourceTxDetails &&
        !!sourceTxDetails &&
        !!sourceTxDetails.is_child_partial_payment,
    },
    (urlTemplate) =>
      urlTemplate.replace("id", sourceTxDetails?.partial_payment_parent_id!)
  );

  return (
    <View
      isLoading={isLoadingRefundDetails}
      isError={isErrorRefundDetails}
      isModalOpen={!!id}
      closeModal={closeModal}
      modalData={refund || null}
      // source tx
      sourceTxDetails={sourceTxDetails || null}
      isLoadingSourceTxDetails={isLoadingSourceTxDetails}
      isErrorSourceTxDetails={isErrorSourceTxDetails}
      // parent tx
      parentTxDetails={parentTxDetails || null}
      isLoadingParentTxDetails={isLoadingParentTxDetails}
      isErrorParentTxDetails={isErrorParentTxDetails}
      // partial payment
      // acceptAsPartialPaymentProps={{
      //   isLoadingFormData: isLoadingRefundDetails || isLoadingSourceTxDetails || isLoadingParentTxDetails,
      //   isFormEnabled: isSuccessRefundDetails && isSuccessSourceTxDetails,
      //   refundAmount: xxxxxxxxx,
      //   refundCurrency: xxxxxxxxx,
      //   transferRefundId: xxxxxxxxx,
      //   transactionId: xxxxxxxxx,
      //   sourceTxBearer: xxxxxxxxx,
      // }}
    />
  );
};
